import { Fragment } from "react";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PaperView from "components/PaperView/PaperView";

const useStyles = makeStyles((_theme) => ({
  container: {},
  item: {},
  paper: {},
  title: {
    marginBottom: "32px",
  },
  titleError: {
    marginBottom: "32px",
    color: "red",
  },
}));

const ViewContainer = ({ children, title, type = "" }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={0}
      direction="row"
      className={classes.container}
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <Grid className={classes.item} size={{ xs: 12, sm: 8, md: 8, lg: 6, xl: 4 }}>
        <PaperView className={classes.paper} square={false}>
          <Typography
            variant="h4"
            align="center"
            className={type == "error" ? classes.titleError : classes.title}
          >
            {title}
          </Typography>
          <Fragment>{children}</Fragment>
        </PaperView>
      </Grid>
    </Grid>
  );
};

export default ViewContainer;
